import submitForm from './submit-form'

export default function (): void {
  const form = document.querySelector<HTMLFormElement>('form[name=reviews_sort]')

  if (form) {
    const formName = form.getAttribute('name')

    document.addEventListener('click', function (e) {
      const target = e.target as HTMLElement

      if (target.matches('.dca-pagination .dca-pagination__prev')) {
        ;(document.getElementById(`${formName}_previousPage`) as HTMLInputElement).value = 'previousPage'
        submitForm(form)
      }

      if (target.matches('.dca-pagination .dca-pagination__next')) {
        ;(document.getElementById(`${formName}_nextPage`) as HTMLInputElement).value = 'nextPage'
        submitForm(form)
      }

      if (target.matches('.dca-pagination .dca-pagination__page-item:not(.dca-pagination__item--active):not(.dca-pagination__item--disabled)')) {
        ;(document.getElementById(`${formName}_goToPage`) as HTMLInputElement).value = target.getAttribute('data-page') as string
        submitForm(form)
      }
    })
  }
}
